import { Box } from "@mui/material";
import { NavKey } from "../../../../model/Nav";
import NavLayout from "../../layout/nav_layout";
import { Mid } from "./component/Mid";
import { CreateExamDialog } from "./component/simulate/CreateSimulateDialog";
import { SimulateList } from "./component/simulate/SimulateList";
import { Top } from "./component/Today";

export function HomePage() {
    return <NavLayout navKey={NavKey.Home} content={<HomeContent />} />;
}

function HomeContent() {
    return (
        <Box sx={{ width: "100%" }}>
            {/* Part1 */}
            <Top />
            {/* Part2 */}
            <Mid />
            {/* Part3 */}
            <Box>
                <ExamListContent />
            </Box>
            {/* float */}
            <CreateExamDialog />
        </Box>
    );
}

interface ExamListContentProps {}
function ExamListContent(props: ExamListContentProps) {
    return (
        <Box>
            {/* <ExamList setDialog={setDialog} /> */}
            <SimulateList />
        </Box>
    );
}

export default HomePage;
